import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {BotaoScrollComponent} from '../botao-scroll/botao-scroll.component';

@Component({
    selector: 'app-layout-principal',
    templateUrl: './layout-principal.component.html',
    styleUrls: ['./layout-principal.component.scss'],
    standalone: false
})
export class LayoutPrincipalComponent implements OnInit {

    @ViewChild('botaoScroll')
    botaoScroll!: BotaoScrollComponent;

    mostrarBotaoScroll = false;
    exibirMapa = false;
    cabecalhoVisivel : boolean = false;
    rodapeVisivel : boolean = false;
    constructor() {
    }

    onRodapeVisibilityChange(visible: boolean): void {
        this.rodapeVisivel = visible
    }

    @HostListener('window:scroll')
    onScroll(): void {
        this.mostrarBotaoScroll = document.documentElement.scrollTop > 10;
    }

    mapaToggle(mostrar: boolean): void {
        this.exibirMapa = mostrar;
        if (mostrar) {
            document.getElementById('mapa')?.scrollIntoView({behavior: 'smooth'});
        }
    }

    ngOnInit(): void {
    }

}